<template>
    <div v-if="visible" class="h-full flex items-center justify-center text-center py-16">
        <div>
                <span :class="`inline-flex h-20 w-20 border-2 border-${color} text-4xl text-${color} rounded-full items-center justify-center mb-8`">
                    <i :class="'fal '+icon"></i>
                </span>
            <p>
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            visible: Boolean,
            icon: {
                default() {
                    return 'fa-info'
                }
            },
            color: {
                default() {
                    return 'grey'
                }
            }
        }
    }
</script>
